import { useCallback, useState } from "react";
import { useAxiosInterceptor } from "src/hooks/useAxiosInterceptor";
import { useParams } from "react-router-dom";
import { GRAPHQL_ENDPOINT } from "src/constants/endpoints";
import { GET_MODIFIER_ITEMS_BY_CATEGORY_ID } from "src/constants/queries";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/store";
import { set_modifier_items} from "src/store/features/modifier-items-slice";
import { UUID } from "src/types/shared.type";
import type { MenuListActiveFilter } from "src/constants/menuListActiveFilter";

export const useModifierItemsByCategoryCorrelationId = () => {

  const [isModifierItemsLoading, setIsModifierItemsLoading] = useState(false);

  const { axBe } = useAxiosInterceptor();
  const { modifierCategoryCorrelationId } = useParams();
  const dispatch = useDispatch();
  
  const { modifierItems, listActiveFilter } = useSelector((state: RootState) => state.modifierItems);

  const fetchModifierItemsByCategoryCorrelationId = useCallback(
    async (activeFilterOverride?: MenuListActiveFilter) => {
      if (!modifierCategoryCorrelationId) return;

      const activeFilter = activeFilterOverride ?? listActiveFilter;

      setIsModifierItemsLoading(true);

      try {
        const variables: {
          modifierCategoryCorrelationId: UUID | undefined;
          activeFilter: MenuListActiveFilter;
        } = { modifierCategoryCorrelationId, activeFilter };
        const { data } = await axBe.post(GRAPHQL_ENDPOINT, {
          query: GET_MODIFIER_ITEMS_BY_CATEGORY_ID,
          variables,
        });

        if (data?.data?.modifierItemsByCategoryCorrelationId) {
          dispatch(set_modifier_items(data.data.modifierItemsByCategoryCorrelationId));
        }
      } catch (err) {
        console.error("Error fetching modifier items by category:", err);
      } finally {
        setIsModifierItemsLoading(false);
      }
    },
    [axBe, dispatch, modifierCategoryCorrelationId, listActiveFilter]
  );

  return {
    modifierItemsByCategory: modifierItems,
    isLoadingModifierItems: isModifierItemsLoading,
    fetchModifierItemsByCategoryCorrelationId,
  };
};
